import { TFunction } from 'i18next';
import ProcessingActivity, {
  PrivacyFramework,
  ProcessingActivityRole,
  ProcessingActivityState,
} from 'models/processingActivity';
import { DataZoneKey } from 'models/stringValue/stringValue';
import ReportRequestDTO from './ReportRequestDTO';

export class ReportRequest20DTO extends ReportRequestDTO {
  processingActivityId: number;

  processingActivityFields: string[];

  processingActivityRoles: Record<ProcessingActivityRole, string>;

  processingActivityStates: Record<ProcessingActivityState, string>;

  transferOptions: Record<DataZoneKey, string>;

  detailsPageTabs: string[];

  constructor(report: ReportRequestDTO, t?: TFunction<string[]>, privacyFramework?: PrivacyFramework) {
    super(report);
    this.processingActivityId = 0;
    this.processingActivityFields = [];
    this.detailsPageTabs = [];
    this.transferOptions = {} as Record<DataZoneKey, string>;
    this.processingActivityRoles = {} as Record<ProcessingActivityRole, string>;
    this.processingActivityStates = {} as Record<ProcessingActivityState, string>;

    if (t && privacyFramework !== undefined) {
      this.processingActivityFields = [
        t('processingActivity:TabDetails.Fields.Name.Label'),
        t('processingActivity:TabDetails.Fields.Code.Label'),
        t('processingActivity:TabDetails.Fields.Owner.Label'),
        t('processingActivity:TabDetails.Fields.Role'),
        t('processingActivity:TabDetails.Fields.State'),
        t('processingActivity:TabDetails.Fields.StartDate'),
        t('processingActivity:TabDetails.Fields.EndDate'),
        t('processingActivity:TabDetails.Fields.RetentionPeriod'),
        t('processingActivity:TabDetails.Fields.Purpose.Label'),
        t('processingActivity:TabDetails.Fields.Description.Label'),
        t('processingActivity:ReportFields.Data'),
        t('processingActivity:ReportFields.Assets'),
        t('processingActivity:TabDetails.StringValueLabels.DataCategories'),
        t('processingActivity:TabDetails.StringValueLabels.DataSubjects'),
        t('processingActivity:TabDetails.StringValueLabels.LegalBasis'),
        t('processingActivity:ReportFields.Controllers'),
        t('processingActivity:ReportFields.JointControllers'),
        t('processingActivity:ReportFields.ProcessorsAndRecipients'),
        t('processingActivity:ReportFields.Processors'),
        t('processingActivity:ReportFields.Recipients'),
        t('processingActivity:ReportFields.RecipientsCategories'),
        t('processingActivity:TabDetails.StringValueLabels.ExecutingEntities'),
        t('processingActivity:TabDetails.Fields.DataSubjectScale'),
        t('processingActivities:TabOverview.Column.Transfers.Label'),
        t('processingActivities:TabOverview.Column.Classifications'),
        t('processingActivity:ReportFields.OrganizationalMeasures'),
        t('processingActivity:ReportFields.Risks'),
        t('processingActivity:ReportFields.Controls'),
      ];
      this.processingActivityRoles = {
        [ProcessingActivityRole.Controller]: t('processingActivity:Role.Controller'),
        [ProcessingActivityRole.Processor]: t('processingActivity:Role.Processor'),
      };
      this.processingActivityStates = {
        [ProcessingActivityState.Concept]: t('processingActivity:State.Concept'),
        [ProcessingActivityState.Approved]: t('processingActivity:State.Approved'),
        [ProcessingActivityState.Archived]: t('processingActivity:State.Archived'),
        [ProcessingActivityState.AwaitingApproval]: t('processingActivity:State.AwaitingApproval'),
        [ProcessingActivityState.Review]: t('processingActivity:State.Review'),
      };

      this.transferOptions = {
        [DataZoneKey.None]: '',
        [DataZoneKey.TenantZone]: ProcessingActivity.getTransfersText(DataZoneKey.TenantZone, t, privacyFramework),
        [DataZoneKey.Adequate]: ProcessingActivity.getTransfersText(DataZoneKey.Adequate, t, privacyFramework),
        [DataZoneKey.Other]: ProcessingActivity.getTransfersText(DataZoneKey.Other, t, privacyFramework),
      };

      this.detailsPageTabs = [
        t('processingActivity:TabDetails.Pivot.Purpose'),
        t('processingActivity:TabDetails.Pivot.Data'),
        t('processingActivity:TabDetails.Pivot.Roles'),
        t('processingActivity:TabDetails.Pivot.Approval'),
      ];
    }
  }

  clone(): ReportRequest20DTO {
    const output = new ReportRequest20DTO(this);
    output.processingActivityId = this.processingActivityId;
    output.processingActivityFields = [...this.processingActivityFields];
    output.processingActivityRoles = { ...this.processingActivityRoles };
    output.processingActivityStates = { ...this.processingActivityStates };
    output.transferOptions = { ...this.transferOptions };
    output.detailsPageTabs = [...this.detailsPageTabs];

    return output;
  }
}
